import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { carsAPI } from '../services/api';

/** تحويل /select-variant/:id إلى /models/:slug */
export function LegacySelectVariantRedirect() {
  const { legacyId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    carsAPI
      .getModel(legacyId)
      .then((res) => {
        if (cancelled) return;
        const m = res.data;
        navigate(`/models/${m.slug || legacyId}`, { replace: true });
      })
      .catch(() => navigate('/', { replace: true }));
    return () => {
      cancelled = true;
    };
  }, [legacyId, navigate]);

  return <div className="spinner" style={{ margin: '48px auto' }} />;
}

/** تحويل /choose-category/:id و /car-viewer/:id إلى /cars/:slug */
export function LegacyChooseCategoryRedirect() {
  const { legacyId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    carsAPI
      .getVariant(legacyId)
      .then((res) => {
        if (cancelled) return;
        const v = res.data;
        navigate(`/cars/${v.slug || legacyId}`, { replace: true });
      })
      .catch(() => navigate('/', { replace: true }));
    return () => {
      cancelled = true;
    };
  }, [legacyId, navigate]);

  return <div className="spinner" style={{ margin: '48px auto' }} />;
}
